import { Box, Image, Link, Text } from "@chakra-ui/react";
import React from "react";

const VisionBox = ({ title, desc, visionImg, visionLink }) => {
  return (
    <Box
      h={"441px"}
      cursor={"pointer"}
      borderRadius={"300px 0px 0px 0px"}
      background={"white"}
      boxShadow={"0px 0px 20px 0px rgba(0, 0, 0, 0.05)"}
      textAlign={"center"}
      transition={"all ease .5s"}
      _hover={{
        boxShadow: "0px 0px 20px 0px rgb(139 139 139 / 70%)",
        ".animated-text": {
          backgroundSize: "100% 100%",
        },
      }}
    >
      <Image src={visionImg} width={"193px"} height={"193px"} />
      <Box mt={4} p={8}>
        <Link href={visionLink ? visionLink : "/what-we-do#ownership"}>
          <Text
            className="animated-text"
            color={"DarkBlue"}
            mb={6}
            fontSize={"21px"}
            display={"inline-block"}
            borderBottom={"1px solid transparent"}
            lineHeight={"1"}
            paddingBottom={"10px"}
            backgroundImage={
              "linear-gradient( 0deg, currentColor 1px, transparent 0)"
            }
            backgroundSize={"0 100%"}
            backgroundRepeat={"no-repeat"}
            transition={
              "background-size .4s ease-in-out, opacity .4s ease-in-out"
            }
          >
            {title}
          </Text>
        </Link>
        <Text color={"DarkBlue"}>{desc}</Text>
      </Box>
    </Box>
  );
};

export default VisionBox;
